import { render, staticRenderFns } from "./CustomerInquiryResolvedWidget.vue?vue&type=template&id=6dfba2d8&scoped=true&"
import script from "./CustomerInquiryResolvedWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerInquiryResolvedWidget.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInquiryResolvedWidget.vue?vue&type=style&index=0&id=6dfba2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfba2d8",
  null
  
)

export default component.exports